import React, { useContext } from 'react'
import GreyBoxForReports from './GreyBoxForReports'
import { ApiGetCall } from '../../JS/Connector';
import { formatDateToMMDDYYYY, LogInUserID, MMDDYYYY } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import useConfig from '../../Hooks/useConfig';

export default function PartsOrderReport({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    const {organization} = useConfig();
    async function GetAllAccountsData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);
        await ApiGetCall(`/reports/part-order-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&userId=${LogInUserID}&flag=${downloadall}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.data?.length > 0) {
                    DownloadCsv(responseRs.data);
                } else {
                    setalerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
                    setTimeout(() => {
                        setalerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            }
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const gradeMap = new Map();
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            var school_name = item.school_name;
            if (!gradeMap.has(school_name)) {
                gradeMap.set(school_name, []);
            }
            item?.parts?.forEach((part) => {
                const rowData = {
                    [`${organization} Name`]: item.school_name || '-',
                    'Requested Part': part.requested_part || '-',
                    'Fulfilled Part': part.fulfilled_part || '-',
                    'Fulfilled NetSuite SKU': part.fulfilled_netsuite_sku || '-',
                    'Total Requested Quantity': part.total_requested_quantity || '-',
                    'Total Fulfilled Quantity': part.total_fulfilled_quantity || '-',
                };
                gradeMap.get(school_name).push(rowData);
            });
        });
        const headers = [`${organization} Name`, 'Requested Part', 'Fulfilled Part', 'Fulfilled NetSuite SKU', 'Total Requested Quantity', 'Total Fulfilled Quantity'];
        csvContent.push(headers);
        gradeMap.forEach((gradeData) => {
            gradeData.forEach((rowData) => {
                const values = Object.values(rowData);
                csvContent.push(values);
            });
        });
        const csvString = csvContent.map(row => row.join(',')).join('\n'); // Convert to CSV string
        const blob = new Blob([csvString], { type: 'text/csv' });  // Create a Blob with the CSV content
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'FulFillPartsOrders.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <GreyBoxForReports icon="faCartArrowDown" name={"Fulfilled Parts Orders Report Download"} onclickfunc={GetAllAccountsData} />
    )
}
